import { useState } from "react";
import styles from '../Settings/AppVersion.module.css'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EventsUpdateLeagueAndTeams from "./EventsUpdateLeagueAndTeams";
import PickEvents from "../AddTickets/PickEvents";

const EventsUpdate = () => {
    const [page, setPage] = useState(0);
    const [resetEvent, setResetEvent] = useState(false)
    const [ticketDetails, setTicketDetails] = useState(null);
    const [search, setSearch] = useState(false);
  return (
        <div className={styles.maindiv}>
            
            <div className={styles.seconddiv} style = { {width: '90%', gap: '0px'}}>
                <EventsUpdateLeagueAndTeams setSearch= {setSearch} setPage = {setPage} setTicketDetails = {setTicketDetails} ticketDetails = {ticketDetails} page = {page} resetEvent={resetEvent} setResetEvent = {setResetEvent}/>
                <PickEvents search = {search} setPage = {setPage} setTicketDetails = {setTicketDetails} ticketDetails = {ticketDetails} page = {page} isFrom={ticketDetails ? 'eventsOtherLeagues'  :'eventsUpdate'} resetEvent={resetEvent} setResetEvent = {setResetEvent}/>
            </div>
        </div>
  )
}

export default EventsUpdate

